import { features } from '@/mocks/comics';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">平台特色</h2>
            <p className="text-sm text-foreground-500">为什么数百万读者选择皮皮漫画</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {features.map((feat, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-colors group"
              >
                <div className="w-11 h-11 mb-4 rounded-xl flex items-center justify-center bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                  <i className={`${feat.icon} text-lg`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}